export const makeFragmentFuncs = (__typename, fragmentName, fragmentDoc) => {
    const getFragment = (id, { cache, getCacheKey }) => {
        const cacheKey = getCacheKey({ __typename, id });
        const fragment = cache.readFragment({
            fragment: fragmentDoc,
            fragmentName,
            id: cacheKey,
        });
        if (fragment) {
            return fragment;
        }
        else {
            throw new Error(`No fragment named ${fragmentName} found for ${cacheKey}`);
        }
    };
    const writeFragment = (data, context) => {
        const { client, getCacheKey } = context;
        const cacheKey = getCacheKey({ __typename, id: data.id });
        client.writeFragment({
            fragment: fragmentDoc,
            fragmentName,
            id: cacheKey,
            data: { __typename, ...data },
        });
    };
    return {
        getFragment,
        writeFragment,
    };
};
export const makeFragmentFuncsWithInit = (__typename, fragmentName, fragmentDoc, initFragment) => {
    const { getFragment, writeFragment } = makeFragmentFuncs(__typename, fragmentName, fragmentDoc);
    const getFragmentOrInit = (src, context) => {
        try {
            return getFragment(src.id, context);
        }
        catch (e) {
            // First time being called, need to initialize
            const newFragment = initFragment(src, context);
            writeFragment(newFragment, context);
            return newFragment;
        }
    };
    return {
        getFragment,
        getFragmentOrInit,
        writeFragment,
    };
};
//# sourceMappingURL=utils.js.map